<template>
  <div class="flex flex-column gap-2">
    <div class="flex justify-content-between">
      <h3>Permissions</h3>
      <a-button
        class="w-fit ml-auto"
        @click="save"
        type="primary"
        :loading="loading"
        :disabled="JSON.stringify(permissions) === JSON.stringify(associate.permissions)"
        >Save</a-button
      >
    </div>
    <div class="w-6"><manager-scope-info /></div>
    <permissions-info :permissions.sync="permissions" :is-visible-scope="true" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import ProfileManagerScope from './profile-manager-scope.vue'
import { notification } from 'ant-design-vue'
import RolePermissions from '@/modules/roles/components/role-permissions.vue'

const { mapActions: profileActions, mapState: profileState } = createNamespacedHelpers('profile')

export default {
  components: {
    'permissions-info': RolePermissions,
    'manager-scope-info': ProfileManagerScope
  },
  data() {
    return {
      permissions: [],

      loading: false
    }
  },
  computed: {
    ...profileState({
      associate: state => state.associate
    })
  },
  watch: {
    associate: {
      handler(newVal) {
        if (newVal) {
          this.permissions = newVal?.permissions ?? []
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...profileActions(['updateAssociate', 'setAssociate']),

    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    async save() {
      this.loading = true

      const payload = {
        associate: {
          ...this.associate,
          permissions: this.permissions
        }
      }

      try {
        const data = await this.updateAssociate(payload)

        this.showNotification('success', 'Info', `Permissions have been edited successfully`)

        this.setAssociate({ ...this.associate, ...data })
      } catch (error) {
        this.showNotification('error', 'Error', typeof error === 'string' ? error : error?.message)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
